export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/rep/resource/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        getInfo(data) {
            return http.json({
                url: `/rep/resource/get?id=${data.id}`,
                data
            })
        },
        queryAll(data) {
            return http.json({
                url: `/rep/resource/queryAll`,
                data
            })
        },
        saveInfo(data) {
            return http.json({
                url: `/rep/resource/save`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/rep/resource/getOne`,
                data
            })
        },


        delete(data) {
            return http.json({
                url: `/rep/resource/delete`,
                data
            })
        },


    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/wkResource.js